export default __webpack_public_path__ + "static/media/statusResolved.74531f59.svg";